<qds-title style="position: relative;" data-layer="main" data-level="section" data-icon="false" data-kicker="false" data-subtitle="false"
          icon="false" class="title-text">HACCP Reports</qds-title>
          
<p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
  <p-tabPanel header="Dashboard"></p-tabPanel>
  
  <p-tabPanel header="Report"></p-tabPanel>
</p-tabView>

<router-outlet></router-outlet>
